// extracted by mini-css-extract-plugin
export var bottomWave = "bw_cj";
export var button = "bw_cd";
export var buttonContainer = "bw_N";
export var buttonFooter = "bw_fF";
export var container = "bw_k";
export var middleWave = "bw_ch";
export var section = "bw_b";
export var subtitle = "bw_ck";
export var textContainer = "bw_bM";
export var title = "bw_f";